import { Flex, Popconfirm, Tag, Tooltip } from 'antd';
import { AuthorizedIcon, Icon } from '../../../../components';
import TrashSolidBlack from '../../../../assets/icons/trash-solid-b-black.svg';
import PenToSquareSolidBlack from '../../../../assets/icons/pen-to-square-solid-w-black.svg';
import EyeRegularWBlack from '../../../../assets/icons/eye-regular-w-black.svg';
import Variant99Black from '../../../../assets/icons/variant99-black.svg';
import FolderOpenRegular from '../../../../assets/icons/folder-open-regular.svg';
import styles from './index.module.scss';
import { status_colors } from '../../../../assets/conts';
import { IEnum } from '../../../../services/type';
import { getValueFromEnum } from '../../../../utils/functions';
import { ColumnType } from 'antd/es/table';
import { actionTypes } from '../../../../assets/enums';
import {
  IFile,
  IOrganization,
  IGroupHealthInsurancePoliciesDataSource,
} from '../../../../types';

export const getColumns = (
  handleClickEye: (id: number) => void,
  handleOpenEditModal: (id: number) => void,
  handleClickDelete: (id: number) => Promise<void>,
  handleClickCancel: (id: number) => Promise<void>,
  handleSetAdditionalFile: (id: number, file: IFile[]) => void,
  organizations: IOrganization[],
  statusChoices: IEnum[],
  policyTypes: IEnum[],
  branch: IEnum[],
): Array<
  ColumnType<IGroupHealthInsurancePoliciesDataSource> & { searchable?: boolean }
> => [
  {
    title: 'Şirket',
    dataIndex: 'organization',
    key: 'organization',
    searchable: true,
    filters: organizations.map((item) => ({
      text: item.name || '',
      value: item.id,
    })),
    sorter: (a, b) => a.organization - b.organization,
    render: (_, record) => (
      <Tooltip
        title={
          organizations.find((item) => item.id === record.organization)?.name
        }
      >
        <span>{`${organizations.find((item) => item.id === record.organization)?.name.slice(0, 15)}...`}</span>
      </Tooltip>
    ),
  },
  {
    title: 'Poliçe No',
    dataIndex: 'policy_number',
    key: 'policy_number',
    searchable: true,
    width: 150,
    sorter: (a, b) => a.policy_number?.localeCompare(b.policy_number),
  },
  {
    title: 'Poliçe Tipi',
    dataIndex: 'doc_type',
    key: 'doc_type',
    width: 150,
    filters: policyTypes.map((item) => ({
      text: getValueFromEnum(policyTypes, item.key) || '',
      value: item.key,
    })),
    filterMode: 'tree',
    filterSearch: true,
    sorter: (a, b) => a.doc_type?.localeCompare(b.doc_type),
    render: (_: unknown, record: IGroupHealthInsurancePoliciesDataSource) => (
      <Tag className={styles[`${record.doc_type}Tag`]}>
        {getValueFromEnum(policyTypes, record.doc_type)}
      </Tag>
    ),
  },
  {
    title: 'Branş',
    dataIndex: 'branch',
    key: 'branch',
    width: 150,
    filters: branch.map((item) => ({
      text: getValueFromEnum(branch, item.key) || '',
      value: item.key,
    })),
    filterMode: 'tree',
    filterSearch: true,
    sorter: (a, b) => a.branch?.localeCompare(b.branch),
    render: (_: unknown, record: IGroupHealthInsurancePoliciesDataSource) => (
      <Tag className={styles[`${record.branch}Tag`]}>
        {getValueFromEnum(branch, record.branch)}
      </Tag>
    ),
  },
  {
    title: 'Başlangıç Tarihi',
    dataIndex: 'start_date',
    key: 'start_date',
    sorter: true,
  },
  {
    title: 'Bitiş Tarihi',
    dataIndex: 'end_date',
    key: 'end_date',
    sorter: true,
  },
  {
    title: 'Durum',
    dataIndex: 'recent_status',
    key: 'recent_status',
    filters: statusChoices.map((item) => ({
      text: getValueFromEnum(statusChoices, item.key) || '',
      value: item.key,
    })),
    filterMode: 'tree',
    filterSearch: true,
    render: (_: unknown, record: IGroupHealthInsurancePoliciesDataSource) => (
      <Tag color={status_colors[record.recent_status]}>
        {getValueFromEnum(statusChoices, record.recent_status)}
      </Tag>
    ),
  },
  {
    title: 'İşlem',
    dataIndex: 'action',
    key: 'action',
    width: 160,
    render: (_: unknown, record: IGroupHealthInsurancePoliciesDataSource) => (
      <Flex justify="flex-end" gap={14}>
        <Icon
          source={EyeRegularWBlack}
          popoverText={actionTypes.VIEW}
          onClick={() => record?.id && handleClickEye(record.id)}
        />
        {record.recent_status !== 'cancelled' && (
          <Popconfirm
            title={
              <div className={styles.popconfirmTitle}>
                İptal işlemini onaylıyor musunuz?
              </div>
            }
            overlayInnerStyle={{
              width: 150,
              borderColor: '#D6222A',
              borderWidth: 1,
              borderStyle: 'solid',
            }}
            okText="Onayla"
            cancelText="İptal"
            icon={null}
            color="#FAFAFA"
            okButtonProps={{ danger: true, style: { width: '45%' } }}
            cancelButtonProps={{ danger: true, style: { width: '45%' } }}
            onConfirm={() => record.id && handleClickCancel(record.id)}
          >
            <AuthorizedIcon
              action="add"
              model="grouphealthinsurancepolicies"
              popoverText={actionTypes.CANCEL}
              source={Variant99Black}
            />
          </Popconfirm>
        )}
        <Popconfirm
          title={
            <div className={styles.popconfirmTitle}>
              Silme işlemini onaylıyor musunuz?
            </div>
          }
          overlayInnerStyle={{
            width: 150,
            borderColor: '#D6222A',
            borderWidth: 1,
            borderStyle: 'solid',
          }}
          okText="Onayla"
          cancelText="İptal"
          icon={null}
          color="#FAFAFA"
          okButtonProps={{ danger: true, style: { width: '45%' } }}
          cancelButtonProps={{ danger: true, style: { width: '45%' } }}
          onConfirm={() => record.id && handleClickDelete(record.id)}
        >
          <AuthorizedIcon
            action="delete"
            model="grouphealthinsurancepolicies"
            popoverText={actionTypes.DELETE}
            source={TrashSolidBlack}
          />
        </Popconfirm>
        <AuthorizedIcon
          action="change"
          model="grouphealthinsurancepolicies"
          source={PenToSquareSolidBlack}
          popoverText={actionTypes.CHANGE}
          onClick={() => record?.id && handleOpenEditModal(record.id)}
        />
        <AuthorizedIcon
          action="view"
          model="grouphealthinsurancepoliciesadditionalfile"
          popoverText={actionTypes.ADDITIONAL_FILE}
          source={FolderOpenRegular}
          onClick={() =>
            handleSetAdditionalFile(record.id, record.additional_files)
          }
        />
      </Flex>
    ),
  },
];
